module.exports = require("composer/formatting");